export default 'webkitTransition' in document.head.style ? 'webkitTransitionProperty' : 'transitionProperty';